{
  "admin-sus-users.chart-failed": "Couldn't load the chart:",
  "admin-sus-users.deselect": "Deselect",
  "admin-sus-users.filter-label": "Filter by name or IP (press Enter):",
  "admin-sus-users.loading": "Loading...",
  "admin-sus-users.mask-label": "Mask (IPv4 only):",
  "admin-sus-users.select": "Select",
  "admin-sus-users.unknown-error": "Unknown error",
  "articles.authorship.author-label": "Authors:",
  "articles.authorship.clear": "Clear",
  "articles.authorship.close": "Close",
  "articles.authorship.disown-cancel": "Cancel",
  "articles.authorship.disown-confirm": "Yes, remove me",
  "articles.authorship.disown-note": "Only the authors listed on this page or an administrator can add you back as an author.",
  "articles.authorship.disown-title": "Remove yourself as an author of this page?",
  "articles.authorship.error-dismiss": "Close",
  "articles.authorship.error-label": "Error:",
  "articles.authorship.needs-one-author": "A page needs at least one author",
  "articles.authorship.save": "Save",
  "articles.authorship.saved": "Saved!",
  "articles.authorship.saving": "Saving...",
  "articles.authorship.title": "Page authors",
  "articles.backlinks.children-heading": "Child pages",
  "articles.backlinks.close": "Close",
  "articles.backlinks.empty": "No pages link to this page",
  "articles.backlinks.error-dismiss": "Close",
  "articles.backlinks.error-label": "Error:",
  "articles.backlinks.includes-heading": "Included in (with [[include]])",
  "articles.backlinks.links-heading": "Backlinks",
  "articles.backlinks.title": "Pages that link to and include this page",
  "articles.child.cancel": "Close",
  "articles.child.child-name-label": "Child page name:",
  "articles.child.close": "Close",
  "articles.child.create": "Create",
  "articles.child.error-dismiss": "Close",
  "articles.child.error-label": "Error:",
  "articles.child.hint-label": "Tip:",
  "articles.child.invalid-name": "Invalid child page name!",
  "articles.child.note": "This creates a new page with this page as its parent.",
  "articles.child.parent-name-label": "This page:",
  "articles.child.title": "Create child page",
  "articles.delete.already-deleted": "This page is already marked as deleted and can't be deleted again",
  "articles.delete.cancel": "Cancel",
  "articles.delete.close": "Close",
  "articles.delete.close-blocked": "Close",
  "articles.delete.confirm": "Delete",
  "articles.delete.confirm-cancel": "Cancel",
  "articles.delete.confirm-permanent": "This permanently deletes the page and can't be undone. Continue?",
  "articles.delete.deleted": "Deleted!",
  "articles.delete.deleting": "Deleting...",
  "articles.delete.error-dismiss": "Close",
  "articles.delete.error-label": "Error:",
  "articles.delete.how-label": "How?",
  "articles.delete.move": "Move to the \"deleted\" category",
  "articles.delete.note": "You can move the page to the \"deleted\" category, or delete it permanently. Permanent deletion can't be undone, so use it with care.",
  "articles.delete.note-no-permanent": "You can delete the page by moving it to the \"deleted\" category. Permanent deletion isn't available.",
  "articles.delete.option-permanent": "Delete permanently",
  "articles.delete.option-rename": "Rename",
  "articles.delete.option-unavailable": " (unavailable)",
  "articles.delete.rename-note": "Adding the prefix \"deleted:\" moves the page to another category (namespace). This works like deleting, but nothing is lost.",
  "articles.delete.title": "Delete page",
  "articles.delete.title-blocked": "Delete page",
  "articles.delete.warning-already-deleted": "This page is already in the \"deleted\" category. To remove it for good, use Delete permanently.",
  "articles.delete.warning-label": "Note:",
  "articles.diff.close": "Close",
  "articles.diff.created-label": "Created:",
  "articles.diff.error-dismiss": "Close",
  "articles.diff.error-label": "Error:",
  "articles.diff.revision-label": "Revision",
  "articles.diff.source-heading": "Source changes:",
  "articles.diff.title": "Compare page revisions",
  "articles.editor.cancel": "Cancel",
  "articles.editor.comment-label": "Short description of changes:",
  "articles.editor.error-dismiss": "Close",
  "articles.editor.error-label": "Error:",
  "articles.editor.loading": "Loading, please wait...",
  "articles.editor.page-title-label": "Title of the page:",
  "articles.editor.preview": "Preview",
  "articles.editor.save": "Save",
  "articles.editor.saved": "Saved!",
  "articles.editor.saving": "Saving...",
  "articles.editor.title-edit": "Edit page",
  "articles.editor.title-new": "Create page",
  "articles.favourite.close": "Close",
  "articles.favourite.count": "{count} favorites",
  "articles.favourite.dismiss": "Close",
  "articles.favourite.error-label": "Error:",
  "articles.favourite.failed": "Something went wrong. Try again later",
  "articles.favourite.private": "Favorites are private. No one, not even the author, can see who favorited this page.",
  "articles.favourite.title": "Favorite this page",
  "articles.favourite.toggle": "Favorite / Unfavorite",
  "articles.files.close": "Close",
  "articles.files.column-name": "File name",
  "articles.files.column-size": "Size",
  "articles.files.column-type": "File type",
  "articles.files.count-label": "Number of files:",
  "articles.files.current-name-label": "Current name:",
  "articles.files.delete": "Delete",
  "articles.files.delete-failed": "Couldn't delete the file",
  "articles.files.drop-hint": "Click to upload, or drag files here",
  "articles.files.error-dismiss": "Close",
  "articles.files.error-label": "Error:",
  "articles.files.new-name-label": "New name:",
  "articles.files.not-uploaded-label": "Not uploaded:",
  "articles.files.options": "Options",
  "articles.files.rename": "Rename",
  "articles.files.rename-cancel": "Cancel",
  "articles.files.rename-confirm": "Rename",
  "articles.files.rename-failed": "Couldn't rename the file",
  "articles.files.rename-title": "Rename",
  "articles.files.site-usage-label": "Space used by site:",
  "articles.files.size-bytes": "{size} bytes",
  "articles.files.title": "Files",
  "articles.files.total-size-label": "Total size:",
  "articles.files.upload": "Upload",
  "articles.files.upload-all": "Upload all",
  "articles.files.upload-failed": "Couldn't upload the file",
  "articles.footnote.heading": "Footnote {number}.",
  "articles.footnote.hint": "(click to scroll to footnotes)",
  "articles.history.authors-added": "Added authors: {added}.",
  "articles.history.authors-added-removed": "Added authors: {added}. Removed authors: {removed}.",
  "articles.history.authors-removed": "Removed authors: {removed}.",
  "articles.history.close": "Close",
  "articles.history.column-actions": "actions",
  "articles.history.column-author": "by",
  "articles.history.column-comment": "comments",
  "articles.history.column-date": "date",
  "articles.history.column-flags": "flags",
  "articles.history.column-revision": "rev.",
  "articles.history.compare": "Compare versions",
  "articles.history.created": "Created a new page",
  "articles.history.date-ago": "{duration} ago",
  "articles.history.error-dismiss": "Close",
  "articles.history.error-label": "Error:",
  "articles.history.file-added": "Uploaded file \"{name}\"",
  "articles.history.file-deleted": "Deleted file \"{name}\"",
  "articles.history.file-renamed": "Renamed file \"{from}\" to \"{to}\"",
  "articles.history.flag-file-added": "File uploaded",
  "articles.history.flag-file-deleted": "File deleted",
  "articles.history.flag-file-renamed": "File renamed",
  "articles.history.flag-migrated": "Revision imported from Wikidot",
  "articles.history.flag-name": "Page renamed or deleted",
  "articles.history.flag-new": "New page created",
  "articles.history.flag-parent": "Parent page changed",
  "articles.history.flag-source": "Source changed",
  "articles.history.flag-tags": "Tags changed",
  "articles.history.flag-title": "Title changed",
  "articles.history.flag-votes": "Rating changed",
  "articles.history.name-changed": "Renamed page \"{from}\" to \"{to}\"",
  "articles.history.parent-changed": "Changed parent page from \"{from}\" to \"{to}\"",
  "articles.history.parent-removed": "Removed parent page \"{parent}\"",
  "articles.history.parent-set": "Set parent page to \"{parent}\"",
  "articles.history.refresh": "update list",
  "articles.history.revert": "Revert to this revision",
  "articles.history.reverted": "Reverted to revision #{revision}",
  "articles.history.tags-added": "Added tags: {added}.",
  "articles.history.tags-added-removed": "Added tags: {added}. Removed tags: {removed}.",
  "articles.history.tags-removed": "Removed tags: {removed}.",
  "articles.history.title": "Page revision history",
  "articles.history.title-changed": "Changed title from \"{from}\" to \"{to}\"",
  "articles.history.view-source": "View source",
  "articles.history.view-version": "View this revision",
  "articles.history.votes-deleted": "Reset page rating: {rating} ({votes} votes, {popularity}% popularity)",
  "articles.lightbox.close": "Close",
  "articles.lightbox.next": "Next",
  "articles.lightbox.number": "Image {current} of {total}",
  "articles.lightbox.prev": "Previous",
  "articles.lock.cancel": "Close",
  "articles.lock.close": "Close",
  "articles.lock.error-dismiss": "Close",
  "articles.lock.error-label": "Error:",
  "articles.lock.locked-label": "Page locked:",
  "articles.lock.note": "Once a page is locked, only members with the Lock pages permission can edit, move or delete it, or change its tags, authors and files. Use it to protect pages such as the home page.",
  "articles.lock.save": "Save",
  "articles.lock.saved": "Saved!",
  "articles.lock.saving": "Saving...",
  "articles.lock.title": "Lock this page",
  "articles.newpage.create-failed": "Couldn't create the page",
  "articles.parent.breadcrumb-wiki-label": "breadcrumbs",
  "articles.parent.breadcrumb-wiki-url": "https://en.wikipedia.org/wiki/Breadcrumb_navigation",
  "articles.parent.cancel": "Close",
  "articles.parent.clear": "Clear",
  "articles.parent.close": "Close",
  "articles.parent.error-dismiss": "Close",
  "articles.parent.error-label": "Error:",
  "articles.parent.note": "Want a clear \"back\" path or a structured site? Set a parent page, one level up, for this page.",
  "articles.parent.note-after-link": ", leave the field empty.",
  "articles.parent.note-before-link": "If you don't want",
  "articles.parent.parent-name-label": "Parent page name:",
  "articles.parent.save": "Set parent",
  "articles.parent.saved": "Saved!",
  "articles.parent.saving": "Saving...",
  "articles.parent.title": "Parent page and breadcrumbs",
  "articles.rating.cancel-vote": "Cancel my vote",
  "articles.rating.close": "Close",
  "articles.rating.dislike": "I don't like it",
  "articles.rating.error-dismiss": "Close",
  "articles.rating.error-label": "Error:",
  "articles.rating.like": "I like it",
  "articles.rating.migrated": "Imported by Wikit",
  "articles.rating.other-voters": "Other votes",
  "articles.rating.popularity-title": "Popularity (share of ratings of 3.0 or higher)",
  "articles.rating.rate-label": "Rate this page:",
  "articles.rating.reset": "Reset rating",
  "articles.rating.reset-cancel": "Cancel",
  "articles.rating.reset-confirm": "Yes, reset it",
  "articles.rating.reset-note": "You can undo this from the page history.",
  "articles.rating.reset-title": "Reset page rating?",
  "articles.rating.stars-label": "rating: ",
  "articles.rating.title": "Page rating",
  "articles.rating.updown-label": "rating: ",
  "articles.rating.votes-title": "Votes",
  "articles.rename.cancel": "Close",
  "articles.rename.close": "Close",
  "articles.rename.current-name-label": "Page name:",
  "articles.rename.error-dismiss": "Close",
  "articles.rename.error-label": "Error:",
  "articles.rename.new-name-label": "New page name:",
  "articles.rename.note": "{action} changes the page's \"unix name\", which is its URL.",
  "articles.rename.note-action": "Renaming",
  "articles.rename.saved": "Saved!",
  "articles.rename.saving": "Saving...",
  "articles.rename.submit": "Rename/move",
  "articles.rename.title": "Rename/move page",
  "articles.source.close": "Close",
  "articles.source.error-dismiss": "Close",
  "articles.source.error-label": "Error:",
  "articles.source.title": "Page source",
  "articles.tags.cancel": "Close",
  "articles.tags.clear": "Clear",
  "articles.tags.close": "Close",
  "articles.tags.error-dismiss": "Close",
  "articles.tags.error-label": "Error:",
  "articles.tags.note": "Tags are a nice way to organize content on your site and create \"horizontal navigation\" between related pages. You can add several tags to each page. Read more about",
  "articles.tags.note-and": " and",
  "articles.tags.save": "Save tags",
  "articles.tags.saved": "Saved!",
  "articles.tags.saving": "Saving...",
  "articles.tags.tag-cloud-wiki-label": "tag clouds",
  "articles.tags.tag-cloud-wiki-url": "https://en.wikipedia.org/wiki/Tag_cloud",
  "articles.tags.tag-wiki-label": "tags",
  "articles.tags.tag-wiki-url": "https://en.wikipedia.org/wiki/Tag_(metadata)",
  "articles.tags.tags-label": "Tags:",
  "articles.tags.title": "Page tags",
  "common.server-unreachable": "Couldn't connect to the server",
  "components.authorship-editor.add-label": "Add author:",
  "components.authorship-editor.search-hint": "(type to search users)",
  "components.tag-editor.add-label": "Add tag:",
  "components.tag-editor.cannot-create": "Only existing tags can be added to this page",
  "components.tag-editor.create": "Create tag \"{tag}\"",
  "components.tag-editor.search-hint": "(type to search tags)",
  "favourites.breadcrumb": "Favorites",
  "favourites.breadcrumb-profile": "Personal",
  "favourites.count": "{count} pages",
  "favourites.crumb": "Favorites",
  "favourites.empty": "You haven't favorited any pages yet.",
  "favourites.title": "My favorites",
  "forum-new-post.title": "New Post",
  "forum-post-options.by": "by",
  "forum-post-options.delete": "Delete",
  "forum-post-options.edit": "Edit",
  "forum-post-options.error-dismiss": "Close",
  "forum-post-options.error-label": "Error:",
  "forum-post-options.hide": "- hide",
  "forum-post-options.last-edited": "Last edited on",
  "forum-post-options.options": "Options",
  "forum-post-options.reply": "Reply",
  "forum-post-options.revisions-title": "Post revisions",
  "forum-post-options.show-more": "Show more",
  "forum-post-options.show-revisions": "Show revisions",
  "forum-thread-options.category-label": "Choose a new category:",
  "forum-thread-options.description-label": "Summary:",
  "forum-thread-options.edit-action": "Edit Title & Description",
  "forum-thread-options.edit-cancel": "Cancel",
  "forum-thread-options.edit-save": "Save",
  "forum-thread-options.edit-title": "Edit thread title and description",
  "forum-thread-options.error-dismiss": "Close",
  "forum-thread-options.error-label": "Error:",
  "forum-thread-options.lock": "Lock Thread",
  "forum-thread-options.move-action": "Move Thread",
  "forum-thread-options.move-cancel": "Cancel",
  "forum-thread-options.move-save": "Save",
  "forum-thread-options.move-title": "Move thread",
  "forum-thread-options.name-label": "Thread title:",
  "forum-thread-options.pin": "Make Sticky",
  "forum-thread-options.saving": "Saving...",
  "forum-thread-options.unlock": "Unlock Thread",
  "forum-thread-options.unpin": "Remove Sticky",
  "forum.likes.close": "Close",
  "forum.likes.dismiss": "Close",
  "forum.likes.error-label": "Error:",
  "forum.likes.failed": "Something went wrong. Try again later",
  "forum.likes.next": "Next",
  "forum.likes.page-of": "page {page} of {total}",
  "forum.likes.previous": "Previous",
  "forum.likes.title": "{count} likes",
  "forum.likes.toggle": "Like",
  "forum.likes.who": "See who liked this",
  "forum.post-editor.cancel": "Cancel",
  "forum.post-editor.description-label": "Summary:",
  "forum.post-editor.error-dismiss": "Close",
  "forum.post-editor.error-label": "Error:",
  "forum.post-editor.loading": "Loading, please wait...",
  "forum.post-editor.post-title-label": "Title:",
  "forum.post-editor.preview": "Preview",
  "forum.post-editor.saved": "Saved!",
  "forum.post-editor.saving": "Saving...",
  "forum.post-editor.submit": "Post",
  "forum.post-editor.thread-title-label": "Thread title:",
  "forum.post-preview.author-label": "Started by:",
  "forum.post-preview.date-label": "Date:",
  "forum.post-preview.description-label": "Summary:",
  "forum.post-preview.preview-label": "Preview:",
  "forum.post-preview.reply-label": "Reply preview:",
  "messages.breadcrumb": "Messages",
  "messages.breadcrumb-profile": "Personal",
  "messages.conversation-list.delete-confirm": "Delete all private messages with the {count} selected users? This only removes them for you, and the other people can still see them. This can't be undone.",
  "messages.conversation-list.delete-confirm-button": "Delete",
  "messages.conversation-list.delete-failed": "Couldn't delete the conversations",
  "messages.conversation-list.delete-selected": "Delete selected",
  "messages.conversation-list.empty": "No conversations yet. Visit anyone's profile to send them a private message.",
  "messages.conversation-list.load-failed": "Couldn't load conversations",
  "messages.conversation-list.loading": "Loading…",
  "messages.conversation-list.select": "Select",
  "messages.conversation-list.select-all": "Select all",
  "messages.conversation-list.select-cancel": "Cancel",
  "messages.conversation-list.selected-count": "{count} selected",
  "messages.conversation-view.cannot-send": "You can't send messages to this user",
  "messages.conversation-view.empty": "No messages yet. Send one to start the conversation.",
  "messages.conversation-view.input-placeholder": "Write a message… (Enter to send, Shift+Enter for a new line)",
  "messages.conversation-view.load-failed": "Couldn't load the conversation",
  "messages.conversation-view.loading": "Loading…",
  "messages.conversation-view.next": "Next →",
  "messages.conversation-view.ok": "OK",
  "messages.conversation-view.report": "Report",
  "messages.conversation-view.report-cancel": "Cancel",
  "messages.conversation-view.report-count": "Report {count} messages",
  "messages.conversation-view.report-failed": "Couldn't submit the report",
  "messages.conversation-view.report-note": "The selected messages and your reason will be sent to the administrators of {site}.",
  "messages.conversation-view.report-placeholder": "Tell the administrators why you're reporting this (up to 2,000 characters)",
  "messages.conversation-view.report-submit": "Submit report",
  "messages.conversation-view.report-submitted": "Report submitted. The administrators will review it shortly.",
  "messages.conversation-view.select-all": "Select all",
  "messages.conversation-view.select-cancel": "Cancel",
  "messages.conversation-view.selected-count": "{count} selected",
  "messages.conversation-view.send": "Send",
  "messages.conversation-view.send-failed": "Couldn't send the message",
  "messages.conversation-view.sending": "Sending…",
  "messages.conversation-view.unknown-user": "User #{id}",
  "messages.conversation-view.with-partner": "Conversation with {partner}",
  "messages.crumb": "Messages",
  "messages.empty": "Select a conversation, or visit anyone's profile to send them a private message.",
  "messages.search": "Find",
  "messages.search-placeholder": "Find a user to message…",
  "messages.searching": "Searching",
  "messages.title": "Private messages",
  "messages.user-not-found": "User not found",
  "notifications.breadcrumb": "Notifications",
  "notifications.breadcrumb-profile": "Personal",
  "notifications.clear-all": "Clear all",
  "notifications.clear-all-confirm": "Clear every notification in this list? This can't be undone.",
  "notifications.clear-confirm-button": "Clear",
  "notifications.clear-selected": "Clear selected",
  "notifications.clear-selected-confirm": "Clear the {count} selected notifications? This can't be undone.",
  "notifications.crumb": "Notifications",
  "notifications.infinite-scroll.empty": "No notifications :(",
  "notifications.item.comment-label": "Comment:",
  "notifications.item.from-author-in": "From {author} in {section}",
  "notifications.item.from-site": "From {site}",
  "notifications.item.liked-by": "{author} liked your post",
  "notifications.item.new-membershipapply": "{sender} submitted a membership application",
  "notifications.item.new-message": "{sender} sent you a private message",
  "notifications.item.new-report": "{sender} reported {subject}",
  "notifications.item.new-ticket": "{sender} submitted a support ticket",
  "notifications.item.release-hint": "It will be installed automatically in the update window once it qualifies. Superusers can postpone or skip it in the admin panel.",
  "notifications.item.release-notes": "Release notes",
  "notifications.item.render-failed": "Couldn't display this notification",
  "notifications.item.result-membershipapply": "Your membership application: {status}",
  "notifications.item.result-report": "Your report on {subject}: {status}",
  "notifications.item.result-ticket": "Your support ticket: {status}",
  "notifications.item.rolled-back-hint": "This version won't be installed automatically again. Superusers can see why it failed in the admin panel.",
  "notifications.item.type-mention": "Mentioned you in the forum",
  "notifications.item.type-new-post": "New forum post",
  "notifications.item.type-post-like": "Like",
  "notifications.item.type-post-reply": "Replied to your post",
  "notifications.item.type-release": "pwikit {version} is out",
  "notifications.item.type-rolled-back": "Update to pwikit {version} failed and was rolled back to {from}",
  "notifications.item.type-watched-edit": "New edit to a page you watch",
  "notifications.item.type-welcome": "Welcome to the site",
  "notifications.item.view-conversation": "View conversation",
  "notifications.item.view-own-tickets": "View my tickets",
  "notifications.item.view-post": "View post",
  "notifications.item.view-ticket": "Review",
  "notifications.kind-all": "All",
  "notifications.kind-direct_message": "Messages",
  "notifications.kind-label": "Filter:",
  "notifications.kind-new_ticket": "Tickets",
  "notifications.kind-post_like": "Likes",
  "notifications.kind-replies": "Replies",
  "notifications.select": "Select",
  "notifications.select-all": "Select all",
  "notifications.select-cancel": "Cancel",
  "notifications.selected-count": "{count} selected",
  "notifications.tab-all": "All",
  "notifications.tab-unread": "Unread",
  "notifications.title": "Notifications",
  "own-likes.breadcrumb": "Likes",
  "own-likes.breadcrumb-profile": "Personal",
  "own-likes.count": "{count} posts",
  "own-likes.crumb": "Likes",
  "own-likes.empty": "You haven't liked any posts yet.",
  "own-likes.title": "Posts I liked",
  "own-likes.untitled": "(untitled)",
  "own-ratings.breadcrumb": "Ratings",
  "own-ratings.breadcrumb-profile": "Personal",
  "own-ratings.count": "{count} pages",
  "own-ratings.crumb": "Ratings",
  "own-ratings.empty": "You haven't rated any pages yet.",
  "own-ratings.title": "Pages I rated",
  "own-tickets.breadcrumb": "Tickets",
  "own-tickets.breadcrumb-profile": "Personal",
  "own-tickets.clear-all": "Clear all",
  "own-tickets.clear-selected": "Clear selected",
  "own-tickets.confirm": "Clear",
  "own-tickets.confirm-clear-all": "Clear everything from My tickets? They'll no longer appear here, but staff can still see them.",
  "own-tickets.confirm-clear-selected": "Clear the {count} selected items? They'll no longer appear here, but staff can still see them.",
  "own-tickets.count": "{count} total",
  "own-tickets.crumb": "Tickets",
  "own-tickets.detail-crumb": "Ticket details",
  "own-tickets.empty": "You haven't submitted any tickets, membership applications or reports.",
  "own-tickets.field-body": "Submission",
  "own-tickets.field-kind": "Type",
  "own-tickets.field-messages": "Reported messages",
  "own-tickets.field-page": "Submitted from",
  "own-tickets.field-reason": "Reason",
  "own-tickets.field-reply": "Staff reply",
  "own-tickets.field-reported": "Reported user",
  "own-tickets.field-reviewed": "Reviewed",
  "own-tickets.field-site": "Site",
  "own-tickets.field-status": "Status",
  "own-tickets.field-submitted": "Submitted",
  "own-tickets.kind-membershipapply": "Membership application",
  "own-tickets.kind-report": "User report",
  "own-tickets.kind-ticket": "Support ticket",
  "own-tickets.no-reply": "No reply yet.",
  "own-tickets.not-found": "This ticket doesn't exist, or you don't have permission to view it.",
  "own-tickets.select": "Select",
  "own-tickets.select-all": "Select all",
  "own-tickets.select-cancel": "Cancel",
  "own-tickets.selected-count": "{count} selected",
  "own-tickets.status-approved": "Approved",
  "own-tickets.status-closed": "Closed",
  "own-tickets.status-dismissed": "Dismissed",
  "own-tickets.status-pending": "Pending",
  "own-tickets.status-rejected": "Rejected",
  "own-tickets.status-reviewed": "Reviewed",
  "own-tickets.title": "My tickets",
  "own-tickets.untitled": "(untitled)",
  "page-404.create-page": "create page",
  "page-404.not-found": "The page {page} you want to access does not exist.",
  "page-login-status.admin": "Admin panel",
  "page-login-status.favourites": "Favorites",
  "page-login-status.liked-posts": "Likes",
  "page-login-status.messages": "Messages",
  "page-login-status.my-tickets": "Tickets",
  "page-login-status.notifications": "Notifications",
  "page-login-status.or": "or",
  "page-login-status.profile": "My account",
  "page-login-status.ratings": "Ratings",
  "page-login-status.settings": "Settings",
  "page-login-status.sign-in": "Sign in",
  "page-login-status.sign-out": "Sign out",
  "page-login-status.sign-up": "Create account",
  "page-login-status.signup-closed": "This site doesn't allow new accounts to sign up.",
  "page-options.authorship": "Authors",
  "page-options.backlinks": "Backlinks",
  "page-options.delete": "Delete",
  "page-options.discuss": "Discuss",
  "page-options.edit": "Edit",
  "page-options.edit-forbidden": "You don't have permission to edit this page.",
  "page-options.error-dismiss": "Close",
  "page-options.error-label": "Error:",
  "page-options.favourite": "Favorite",
  "page-options.files": "Files",
  "page-options.hint.authorship": "View and change the authors recorded for this page.",
  "page-options.hint.backlinks": "See pages that link to and include this page.",
  "page-options.hint.delete": "Delete this page, or move it to the deleted category.",
  "page-options.hint.discuss": "If you want to discuss contents of this page - this is the easiest way to do it.",
  "page-options.hint.edit": "Click here to edit contents of this page.",
  "page-options.hint.favourite": "Add this page to your favorites, or remove it.",
  "page-options.hint.files": "View and manage file attachments for this page.",
  "page-options.hint.history": "Check out how this page has evolved in the past.",
  "page-options.hint.lock": "Lock this page so only administrators can edit it.",
  "page-options.hint.more": "Show more page tools.",
  "page-options.hint.new-child": "Create a new page with this page as its parent.",
  "page-options.hint.parent": "View/set parent page (used for creating breadcrumbs and structured layout).",
  "page-options.hint.rate": "Rate this page and see the votes cast.",
  "page-options.hint.rename": "Change the name (also URL address, possibly the category) of the page.",
  "page-options.hint.source": "View wiki source for this page without editing.",
  "page-options.hint.tags": "View and edit the tags of this page.",
  "page-options.history": "History",
  "page-options.lock": "Lock Page",
  "page-options.more": "Options",
  "page-options.new-child": "New Child Page",
  "page-options.parent": "Parent",
  "page-options.rate": "Rate",
  "page-options.rename": "Rename",
  "page-options.saving": "Saving...",
  "page-options.source": "Page Source",
  "page-options.tags": "Tags",
  "page-options.watch-start": "Watch",
  "page-options.watch-stop": "Unwatch",
  "page.header.back-to-site": "Back to site",
  "page.navigation.edit-profile": "Settings",
  "page.navigation.favourites": "Favorites",
  "page.navigation.liked-posts": "Likes",
  "page.navigation.messages": "Messages",
  "page.navigation.my-tickets": "Tickets",
  "page.navigation.notifications": "Notifications",
  "page.navigation.profile": "Profile",
  "page.navigation.ratings": "Ratings",
  "page.profile-page.title": "User profile",
  "search.author-placeholder": "Author",
  "search.category-placeholder": "Category",
  "search.comment-count": "{count} comments",
  "search.created": "Created {when}",
  "search.days-ago": "{count}d ago",
  "search.empty": "No pages found.",
  "search.failed": "Search failed. Try again later.",
  "search.hours-ago": "{count}h ago",
  "search.just-now": "just now",
  "search.load-more": "Load more",
  "search.minutes-ago": "{count}m ago",
  "search.months-ago": "{count}mo ago",
  "search.placeholder": "Search…",
  "search.tags-placeholder": "Tags (separate with spaces, - to exclude)",
  "search.total": "{total} results",
  "search.updated": "Updated {when}",
  "search.years-ago": "{count}y ago",
  "user-actions.block": "Block",
  "user-actions.cancel": "Cancel",
  "user-actions.confirm": "OK",
  "user-actions.confirm-block": "Once blocked, this user can't send you private messages. Block them?",
  "user-actions.confirm-unblock": "Unblock this user?",
  "user-actions.failed": "Something went wrong",
  "user-actions.unblock": "Unblock",
  "util.date-format.day-1": "Mon",
  "util.date-format.day-2": "Tue",
  "util.date-format.day-3": "Wed",
  "util.date-format.day-4": "Thu",
  "util.date-format.day-5": "Fri",
  "util.date-format.day-6": "Sat",
  "util.date-format.day-7": "Sun",
  "util.date-format.days": "{days}d",
  "util.date-format.hours": "{hours}h",
  "util.date-format.minutes": "{minutes}m",
  "util.date-format.month-1": "Jan",
  "util.date-format.month-10": "Oct",
  "util.date-format.month-11": "Nov",
  "util.date-format.month-12": "Dec",
  "util.date-format.month-2": "Feb",
  "util.date-format.month-3": "Mar",
  "util.date-format.month-4": "Apr",
  "util.date-format.month-5": "May",
  "util.date-format.month-6": "Jun",
  "util.date-format.month-7": "Jul",
  "util.date-format.month-8": "Aug",
  "util.date-format.month-9": "Sep",
  "util.date-format.seconds": "{seconds}s",
  "util.fetch-util.read-failed": "Couldn't read the response",
  "util.pagination.next": "next »",
  "util.pagination.page-of-total": "page {page} of {maxPages}",
  "util.pagination.previous": "« previous",
  "util.wikidot-message.author-label": "Author:",
  "util.wikidot-message.date-label": "Date created:",
  "util.wikidot-message.dismiss": "Close message",
  "util.wikidot-message.page-label": "Page name:",
  "util.wikidot-message.preview-note": "This is a preview only.",
  "util.wikidot-message.revision-label": "Revision:",
  "util.wikidot-message.to-editor": "Down to the edit form",
  "util.wikidot-message.to-revisions": "Down to the revision list",
  "util.wikidot-message.unsaved-note": "If you leave this page now, your changes won't be saved.",
  "util.wikidot-modal.confirm-cancel": "Cancel",
  "util.wikidot-modal.error-dismiss": "Close",
  "util.wikidot-modal.error-label": "Error:",
  "util.wikidot-modal.revert-cancel": "Cancel",
  "util.wikidot-modal.revert-confirm": "Do you really want to revert to revision {revision}?",
  "util.wikidot-modal.revert-confirm-button": "Yes, revert",
  "util.wikidot-modal.revert-title": "Revert page revision?"
}
